import { render, staticRenderFns } from "./excmCustomFields.vue?vue&type=template&id=25497def&"
import script from "./excmCustomFields.vue?vue&type=script&lang=js&"
export * from "./excmCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports